export const RESET = 'VIDEO_LIST_RESET';
export const SET_ITEMS = 'VIDEO_LIST_SET_ITEMS';
export const SET_ERROR = 'VIDEO_LIST_SET_ERROR';
export const SET_SELECT_ITEMS = 'VIDEO_LIST_SET_SELECT_ITEMS';
export const SET_VIEW = 'VIDEO_LIST_SET_VIEW';
export const TOGGLE_LOADING = 'VIDEO_LIST_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/video/list/mutation_types.js